import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import React from 'react';
import ViewStyleControl from './ViewStyleControl';
import SortControl from './SortControl';
import FilterControl from './FilterControl';
import GroupControl from './GroupControl';
import { jsx as ___EmotionJSX } from "@emotion/react";
const CollectionControlsContainer = /*#__PURE__*/_styled("div", {
  target: "emfmed70",
  label: "CollectionControlsContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "md893e",
  styles: "display:flex;flex-direction:row;align-items:center;justify-content:flex-end;gap:8px;margin:1rem;width:auto"
} : {
  name: "md893e",
  styles: "display:flex;flex-direction:row;align-items:center;justify-content:flex-end;gap:8px;margin:1rem;width:auto",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
function CollectionControls({
  isSearchResults,
  viewStyle,
  onChangeViewStyle,
  sortableFields,
  onSortClick,
  sort,
  viewFilters,
  viewGroups,
  onFilterClick,
  onGroupClick,
  t,
  filter,
  group
}) {
  return ___EmotionJSX(CollectionControlsContainer, null, ___EmotionJSX(ViewStyleControl, {
    viewStyle: viewStyle,
    onChangeViewStyle: onChangeViewStyle
  }), !isSearchResults && ___EmotionJSX(React.Fragment, null, viewGroups.length > 0 && ___EmotionJSX(GroupControl, {
    viewGroups: viewGroups,
    onGroupClick: onGroupClick,
    t: t,
    group: group
  }), viewFilters.length > 0 && ___EmotionJSX(FilterControl, {
    viewFilters: viewFilters,
    onFilterClick: onFilterClick,
    t: t,
    filter: filter
  }), sortableFields.length > 0 && ___EmotionJSX(SortControl, {
    fields: sortableFields,
    sort: sort,
    onSortClick: onSortClick
  })));
}
export default CollectionControls;